import { ExpertiseToTransformWrapper } from "../../styles/StyledComponents/ExpertiseToTransformWrapper";
import { TechnologyCardMock } from "../../ui/json/demo.mock";
import TechnologyCard from "./TechnologyCard";

const ExpertiseToTransform = () => {
  return (
    <ExpertiseToTransformWrapper className="cmn_gap_btm">
      <div className="container">
        <div className="technology_Marketing_Wrap">
          <div className="technology_row">
            <div className="row">
              <div className="heading_right col">
                <h2>
                  Expertise to Transform Business with{" "}
                  <span>Technology And Marketing</span>
                </h2>
              </div>
              <div className="col">
                <p>
                  EMIIT, an award-winning web design company, combines 14+ years
                  of expertise with a creative and technical approach to build
                  unique digital presences. We help brands stand out in a
                  crowded digital landscape, providing tailored web development
                  solutions, design strategy, and digital marketing services to
                  ensure business success and growth.
                </p>
              </div>
            </div>
          </div>
          <div className="technologyCardWrap">
            <div className="row">
              {TechnologyCardMock?.map((data, index) => (
                <div className="col_6" key={index}>
                  <TechnologyCard {...data} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </ExpertiseToTransformWrapper>
  );
};

export default ExpertiseToTransform;
